import { TextFieldEntry } from '@bpmn-io/properties-panel';
import { html } from "htm/preact";

import { useService } from 'bpmn-js-properties-panel';

import ExtensionList from './ExtensionList';


export default function ParameterProps(props) {

  const {
    idPrefix,
    parameter
  } = props;

  const entries = [ 
    {
      id: idPrefix + '-name',
      component: Name,
      idPrefix,
      parameter
    },
    {
      id: idPrefix + '-value',
      component: Value,
      idPrefix,
      parameter
    },
    {
      id: idPrefix + '-extensions',
      component: ExtensionList,
      idPrefix,
      parameter
    }
  ];

  return entries;
}

function Name(props) {
  const {
    idPrefix,
    element,
    parameter
  } = props;

  const commandStack = useService('commandStack');
  const translate = useService('translate');
  const debounce = useService('debounceInput');

  const setValue = (value) => {
    commandStack.execute('element.updateModdleProperties', {
      element,
      moddleElement: parameter,
      properties: {
        name: value
      }
    });
  };

  const getValue = (parameter) => {
    return parameter.name;
  };

  return TextFieldEntry({
    element: parameter,
    id: idPrefix + '-name',
    label: translate('File Name'),
    getValue,
    setValue,
    debounce
  });
}

function Value(props) {
  const {
    idPrefix,
    element,
    parameter
  } = props;

  const commandStack = useService('commandStack');
  const translate = useService('translate');
  const debounce = useService('debounceInput');
  const modeling = useService("modeling");

  const setValue = (value) => {
    parameter.value = value.target.value;
  }

  const getValue = () => {
    return parameter.value;
  };

  return [
    html`<div class="bio-properties-panel-entry" data-entry-id="Collaboration_129s9ef-parameter-1-name">
    <div class="bio-properties-panel-textfield">
    <label for="bio-properties-panel-Collaboration_129s9ef-parameter-1-name" class="bio-properties-panel-label">
    File URL
    </label>
    <input
      type="text"
      id="properties_panel_input_${element.id}"
      class="bio-properties-panel-input"
      value=${getValue()}
      oninput=${setValue}
    /><br /><a
        id="properties_panel_link_${element.id}"
        href="${getValue()}"
        >Open Document</a>
    </div></div>`
  ];
}